import { gql } from "@apollo/client";

// Where else a question is used, for the "Fix everywhere" choice. The reach is a field of
// the step, so the query asks through the one step the question belongs to.
export default gql`
  fragment ReviewQuestionReach on AssessmentTemplateNode {
    id
    questionReach(questionId: $questionId) {
      questionId
      otherReviewCount
      inLibrary
    }
  }

  query getReviewQuestionReach(
    $complianceProgramId: Int!
    $questionId: Int!
    $performance: Boolean!
    $manager: Boolean!
    $peer: Boolean!
    $engagementSurvey: Boolean!
  ) {
    complianceProgram(pk: $complianceProgramId) {
      id
      performanceAssessmentTemplate @include(if: $performance) {
        ...ReviewQuestionReach
      }
      managerAssessmentTemplate @include(if: $manager) {
        ...ReviewQuestionReach
      }
      peerAssessmentTemplate @include(if: $peer) {
        ...ReviewQuestionReach
      }
      engagementSurveyTemplate @include(if: $engagementSurvey) {
        ...ReviewQuestionReach
      }
    }
  }
`;
